import React from "react";
import { Helmet } from "react-helmet-async";
import { useI18n } from "../../lib/i18n";
import { resolveImage } from "../admin/ImageUpload";

/** Injects <head> tags from a SEO dict + fallbacks. */
const Seo = ({ seo, fallbackTitle, fallbackDescription, fallbackImage, url }) => {
  const { pick, lang } = useI18n();
  const s = seo || {};
  const title = pick(s.title, "") || fallbackTitle || "Fırat Construction Yapı A.Ş.";
  const description = pick(s.description, "") || fallbackDescription || "";
  const image = s.og_image || fallbackImage || "";
  const abs = resolveImage(image);
  const noindex = !!s.noindex;

  return (
    <Helmet>
      <html lang={lang} dir={lang === "ar" ? "rtl" : "ltr"} />
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      {s.keywords ? <meta name="keywords" content={s.keywords} /> : null}
      {s.canonical ? <link rel="canonical" href={s.canonical} /> : null}
      {noindex ? <meta name="robots" content="noindex,nofollow" /> : null}

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      {description ? <meta property="og:description" content={description} /> : null}
      {abs ? <meta property="og:image" content={abs} /> : null}
      {url ? <meta property="og:url" content={url} /> : null}
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description ? <meta name="twitter:description" content={description} /> : null}
      {abs ? <meta name="twitter:image" content={abs} /> : null}
    </Helmet>
  );
};

export default Seo;
